import { useCallback } from "react";

export default function OrderAdminActions({
  adminFetch,
  apiBaseUrl,
  readApiJson,
  setAdminOrders,
  fetchAdminData,
  setAdminError
}) {
  const formatCollectedPrice = useCallback((item) => {
    const price = Number(item?.price || 0);
    if (price > 0) {
      return `RMB ${price.toFixed(2)}`;
    }
    return "-";
  }, []);

  const updateOrderStatus = useCallback(async (orderId, status) => {
    try {
      const response = await adminFetch(`${apiBaseUrl}/admin/orders/${orderId}/status`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status })
      });

      const data = await readApiJson(response);
      if (!response.ok) {
        throw new Error(data.message || "Order update failed");
      }

      setAdminOrders((prev) =>
        prev.map((item) => (item.id === orderId ? data.order : item))
      );
      await fetchAdminData();
    } catch (err) {
      if (err.message !== "Session expired") {
        setAdminError(err.message);
      }
    }
  }, [adminFetch, apiBaseUrl, fetchAdminData, readApiJson, setAdminError, setAdminOrders]);

  return {
    formatCollectedPrice,
    updateOrderStatus
  };
}